/**
 * ActivationPaymentsAddDeviceCtrl controller
 */

import CheckUncheckDevices from './checkUncheckDevices.class'

/**
 * ActivationPaymentsAddDeviceCtrl controller
 *
 * @class ActivationPaymentsAddDeviceCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
 */
/* @ngInject */
export default function ActivationPaymentsAddDeviceCtrl ($scope, subscr, extra, scope) {
  var vm = this

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  vm.extra = extra

  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  vm.scope = scope

  /**
   * Return blank payment request
   * When user changes payment type, for exmple, we need new blank payment request, without old data
   *
   * @function
   */
  const getBlankPaymentRequest = (defaults = {}) => ({
    devicesToPay: null,
    override: true,
    ...defaults
  })

  /**
   * Blank for PaymentRequest
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  const payment = vm.payment = getBlankPaymentRequest()

  /**
   * Object with extra devices, which we want to include in TOP subscription, doing 'Add Devices' operation
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  const includeDevicesTopUp = vm.includeDevicesTopUp = new CheckUncheckDevices()
  const updateIncludeDevicesTopUp = () => {
    includeDevicesTopUp.update(
      /* min */ extra.addDevicesInfoTopUp.alreadyPaidDevices + 1,
      /* max */ Math.min(
        scope.devices.count(),
        extra.addDevicesInfoTopUp.alreadyPaidDevices + extra.addDevicesInfoTopUp.allowedDevicesToPay,
        scope.settings.ACTIVATION_DEVICE_LIMIT
      )
    ).includeFirst()
  }
  updateIncludeDevicesTopUp()

  /**
   * Object with extra devices, which we want to include in CURRENT subscription, doing 'Add Devices' operation
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  const includeDevicesOverride = vm.includeDevicesOverride = new CheckUncheckDevices()
  const updateIncludeDevicesOverride = () => {
    includeDevicesOverride.update(
      /* min */ extra.addDevicesInfoOverride.alreadyPaidDevices + 1,
      /* max */ Math.min(
        scope.devices.count(),
        extra.addDevicesInfoOverride.alreadyPaidDevices + extra.addDevicesInfoOverride.allowedDevicesToPay,
        scope.settings.ACTIVATION_DEVICE_LIMIT
      )
    ).includeFirst()
  }
  updateIncludeDevicesOverride()

  /**
   * Object with extra devices, which we want to include, doing 'Add Devices' operation
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  let includeDevices = vm.includeDevices = null
  const updateIncludeDevices = () => {
    if (includeDevicesOverride.count() > 0) {
      includeDevices = vm.includeDevices = includeDevicesOverride
      payment.override = true
    } else
    if (includeDevicesTopUp.count() > 0) {
      includeDevices = vm.includeDevices = includeDevicesTopUp
      payment.override = false
    }
  }
  updateIncludeDevices()

  // catch event from ActivationDevicesCtrl controller, when user adds or removes slots
  $scope.$parent.$on('event:deviceSlotsAmountChanged', function () {
    updateIncludeDevicesTopUp()
    updateIncludeDevicesOverride()
    updateIncludeDevices()

    // if after we remove slots we cannot add devices anymore -> reset payment type
    if (!scope.can.Add_Device()) {
      scope.change.paymentType()
    }
  })

  /**
   * Actions on change form fields
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsAddDeviceCtrl
   * @type {Object}
   */
  vm.change = {

    /**
     * Change override type
     */
    overrideFlag () {
      includeDevices = vm.includeDevices =
        payment.override
          ? includeDevicesOverride
          : includeDevicesTopUp
      scope.calculate()
    }
  }

  /*
   * Get part of payment from child view,
   * Overwritten from child controllers
   */
  scope.getChildPayment = () =>
    ({
      ...payment,
      devicesToPay: includeDevices.count()
    })

  // call parent calculate
  scope.calculate()
  $scope.$watch('vm.includeDevices.max', (n, o) => {
    if (n < o) {
      vm.scope.calculate()
    }
  })
}
